module.exports = __webpack_public_path__ + "static/fonts/Nunito-SemiBold.6fd28dc.woff";